<script>
  import Header from "../components/Header.svelte";
  import { projects } from "../json/projects";
</script>

<Header />

<main>
  <h1 class="page">PROJECTS</h1>

  {#each projects as { id, name, src, description, link, github, tags } (id)}
    <div class="project">
      <a href={link} target="_blank"><img {src} alt={name} loading="lazy" /></a>

      <div class="article">
        <h2>{name}</h2>
        <p>{description}</p>

        <div class="links">
          <a href={link}>Live Link</a>
          <a href={github}>Github</a>
        </div>
      </div>

      <div class="technologies">
        {#each tags as tag}
          <p>{tag}</p>
        {/each}
      </div>
    </div>
  {/each}
</main>

<style>
  main {
    padding: 1em;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .page {
    font-size: 2em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1em;
  }

  .project {
    text-align: center;
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: 1fr;
    width: 800px;
    margin: auto;
    margin-bottom: 3em;
    padding: 1em;
  }

  .project img {
    width: 100%;
    border-radius: 1em;
  }

  .project h2 {
    font-size: 1.5em;
    margin: 0;
  }

  .article {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .article p {
    padding: 0 10px;
  }

  .technologies {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    gap: 0.5em;
    grid-column: 1/3;
  }

  .technologies > p {
    /* background-color: #777c90; */
    border: 1px solid white;
    border-radius: 1em;
    padding: 2px 10px;
    cursor: context-menu;
    transition: 300ms;
  }
  .technologies > p:hover {
    background-color: white;
    color: black;
  }

  .links {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }

  .links a {
    color: var(--mainColor);
    border: 1px solid var(--mainColor);
    border-radius: 1em;
    padding: 2px 10px;
    transition: 300ms;
    text-decoration: none;
  }
  .links a:hover {
    background-color: var(--mainColor);
    color: white;
  }

  p {
    grid-column: 0/3;
  }

  @media (max-width: 992px) {
    .project {
      width: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    .technologies {
      display: flex;
      justify-content: center;
    }
  }
</style>
